import type { StatusTone } from '../../../ui-kit';
import type { WaState } from '../../../services/websiteAssistantService';

/** The chip a chat wears, in every list and in its story. */
const CHIPS: Record<WaState, { tone: StatusTone; label: string }> = {
  chatting: { tone: 'good', label: 'Chatting now' },
  left: { tone: 'neutral', label: 'Left before finishing' },
  lead_sent: { tone: 'good', label: 'In AgencyZoom' },
  lead_failed: { tone: 'bad', label: 'Not sent to AgencyZoom' },
  answered: { tone: 'good', label: 'Answered' },
  handed: { tone: 'warning', label: 'Passed to the team' },
};

export function stateChip(state: WaState): { tone: StatusTone; label: string } {
  return CHIPS[state] ?? { tone: 'neutral', label: state };
}

/** What a chat was about, in words. */
export function intentOf(intent: 'quote' | 'question' | null): string {
  return intent === 'quote' ? 'Auto quote' : intent === 'question' ? 'Question about a policy' : 'Did not say';
}
